module.exports = __webpack_public_path__ + "static/images/promo-icon.3u5sTMX.svg";